import React from 'react'

import Tool, { ToolTypeModel } from '~/models/tool'

import { makeToolTagPropsList } from '~/common/define/tag'
import { toolEditPath } from '~/common/define/tool'
import { toolIconTag } from '~/common/define/toolType/toolTypePropsAttr'
import { dateTimeStr } from '~/common/utils/datetime'
import Row from '~/components/atoms/row/Row'
import RowBaseLayout, { RowBaseLayoutSize } from '~/components/molecules/row/content/RowBaseLayout'
import SwitchLink from '~/components/atoms/link/SwitchLink'

interface Props {
  tool: Tool
  size: RowBaseLayoutSize
}

const ToolRow = ({tool, size}: Props) => {
  return (
    <Row key={tool.id} clickable>
      <SwitchLink link={toolEditPath(tool)} external={tool.type == ToolTypeModel.LINK}>
        <RowBaseLayout
          tagList={makeToolTagPropsList(tool)}
          content={tool.name}
          iconProps={{
            tag: toolIconTag(tool.type),
          }}
          date={dateTimeStr(tool.updated_at as Date)}
          size={size}
        />
      </SwitchLink>
    </Row>
  )
}

export default ToolRow